import { CDN_ASSETS_URL } from 'constants/global';
import { Props as MaskedImageProps } from 'components/MaskedImage';

const heightForWidth = (width: number) => (width / 16) * 9;

export const getMaskedImageConfigForInterior = (
  interior: 'loft' | 'moscow' | 'mac' | 'lounge',
): MaskedImageProps => {
  switch (interior) {
    case 'loft':
      return {
        imageUrl: `${CDN_ASSETS_URL}interiors/loft-2.jpg`,
        secondaryImageUrl: `${CDN_ASSETS_URL}interiors/loft-2-device.png`,
        gapX: 609,
        gapY: 189,
        gapSize: { width: 701, height: heightForWidth(701) },
      };
    case 'moscow':
      return {
        imageUrl: `${CDN_ASSETS_URL}interiors/moscow-2.jpg`,
        secondaryImageUrl: `${CDN_ASSETS_URL}interiors/moscow-2-device.png`,
        gapX: 623,
        gapY: 231,
        gapSize: { width: 685, height: heightForWidth(685) },
      };
    case 'mac':
      return {
        imageUrl: `${CDN_ASSETS_URL}interiors/mac-2.jpg`,
        secondaryImageUrl: `${CDN_ASSETS_URL}interiors/mac-2-device.png`,
        gapX: 572,
        gapY: 283,
        gapSize: { width: 775, height: heightForWidth(775) },
      };
    case 'lounge':
      return {
        imageUrl: `${CDN_ASSETS_URL}interiors/lounge.png`,
        secondaryImageUrl: `${CDN_ASSETS_URL}interiors/lounge-device.png`,
        gapX: 814,
        gapY: 223,
        gapSize: { width: 658, height: heightForWidth(658) },
      };
  }
};
